<template>
  <div class="main-content">
    <div v-for="( item, index ) in mainList" :key="index">
      <div class="main-item" v-if="mainDetail[`${item.key}State`] === 0 || item.name === '活动时间'">
        <div class="main-title">{{ item.name }}</div>
        <p v-if="item.name !== '附件资料'" class="main-p">{{item.name === '活动时间' ?  mainDetail.beginTime+' 到 '+mainDetail.endTime : mainDetail[item.key]}}</p>
        <div class="main-a" v-else v-for="(item, index) in JSON.parse(mainDetail[item.key] ? mainDetail[item.key] : null)" :key="index" target="_blank"  :href="item.fileUrl" @click="download(item)">{{item.name}} </div>

      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "index",
  props: {
    mainDetail: {
      type: Object,
      default: {}
    },
  },
  data() {
    return {

      mainList:[
        { name: '大赛背景', key: 'contestIntroduction'},
        { name: '组织单位', key: 'orgUnit'},
        { name: '活动时间', key: ''},
        { name: '参与对象', key: 'participationObject'},
        { name: '大赛流程', key: 'competitionProcess'},
        { name: '大赛详情', key: 'competitionDetail'},
        { name: '大赛奖励', key: 'competitionReward'},
        { name: '联系方式', key: 'contactInformation'},
        { name: '附件资料', key: 'appendix'},
      ],
    }
  },
  methods:{
    download (item) {
      const x = new window.XMLHttpRequest();
      x.open('GET', item.fileUrl, true);
      x.responseType = 'blob';
      x.onload = () => {
        const url = window.URL.createObjectURL(x.response);
        const a = document.createElement('a');
        a.href = url;
        a.download = item.name;
        a.click();
      };
      x.send();
    }
  }

}
</script>

<style scoped lang="scss">

.main-content {
  background-color: #FFFFFF;
  padding: 47px;
  .main-item {
    position: relative;
  }
  .main-item::before{
    content: '';
    display: inline-block;
    width: 10px;
    height: 10px;
    background-color: #FF6900;
    position: absolute;
    top: -20px;
    left: 35px;
  }

  .main-title {
    font-size: 26px;
    font-weight: 800;
    margin: 20px 30px;
    position: relative;
  }

  .main-title::before {
    content: '';
    display: inline-block;
    width: 20px;
    height: 15px;
    background-color: #FF6900;
    position: absolute;
    top: 0px;
    left: -30px;
  }
  .main-title::after {
    content: '';
    display: inline-block;
    width: 9px;
    height: 9px;
    background-color: #FF6900;
    position: absolute;
    top: 24px;
    left: 110px;
  }
  .main-p {
    font-size: 18px;
    font-weight: 400;
    color: #636363;
    line-height: 40px;
    margin-bottom: 50px;
    white-space: pre-line;
  }
  .main-a {
    cursor: pointer;
    display: block;
    margin-bottom: 10px;
    color: #2d6afe;
  }
}
</style>
